import * as React from 'react'
import Typography from '@mui/material/Typography'

export default function Timestamp({
  children, at, locales, localeOptions, ...props
}){
  if (at) {
    const date = new Date(at)
    children = <>
      <span style={{whiteSpace: 'nowrap'}}>{date.toLocaleDateString(locales, localeOptions)} </span>
      <wbr/>
      <span style={{whiteSpace: 'nowrap'}}>{date.toLocaleTimeString(locales, localeOptions)}</span>
    </>
  }
  return <Typography
    {...props}
    sx={{
      fontSize: 'smaller',
      ...props.sx
    }}
  >{children}</Typography>
}

Timestamp.defaultProps = {
  variant: 'body1',
  component: 'span',
}
